module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/3x2-flatpack-mobile-6a3429dd325ef1966c5950a2ee4d4b89.png";